var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineBackwardItem(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.15 11.75c-2.66 0-3.9-1.24-3.9-3.9v-2.7c0-2.66 1.24-3.9 3.9-3.9h2.7c2.66 0 3.9 1.24 3.9 3.9v2.7c0 2.66-1.24 3.9-3.9 3.9h-2.7zm-2.4-6.6v2.7c0 1.84.56 2.4 2.4 2.4h2.7c1.84 0 2.4-.56 2.4-2.4v-2.7c0-1.84-.56-2.4-2.4-2.4h-2.7c-1.84 0-2.4.56-2.4 2.4zM5.15 22.75c-2.66 0-3.9-1.24-3.9-3.9v-2.7c0-2.66 1.24-3.9 3.9-3.9h2.7c2.66 0 3.9 1.24 3.9 3.9v2.7c0 2.66-1.24 3.9-3.9 3.9h-2.7zm-2.4-6.6v2.7c0 1.84.56 2.4 2.4 2.4h2.7c1.84 0 2.4-.56 2.4-2.4v-2.7c0-1.84-.56-2.4-2.4-2.4h-2.7c-1.84 0-2.4.56-2.4 2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.001 18.13c-.41 0-.75-.34-.75-.75v-1.23c0-1.84-.56-2.4-2.4-2.4h-1.23c-.41 0-.75-.34-.75-.75v-2.62c0-3.12 1.39-4.51 4.51-4.51h2.62c.41 0 .75.34.75.75v1.23c0 1.84.56 2.4 2.4 2.4h1.23c.41 0 .75.34.75.75v2.62c0 3.12-1.39 4.51-4.51 4.51h-2.62zm2.62-1.5c2.28 0 3.01-.73 3.01-3.01v-1.87h-.48c-2.66 0-3.9-1.24-3.9-3.9v-.48h-1.87c-2.28 0-3.01.73-3.01 3.01v1.87h.48c2.66 0 3.9 1.24 3.9 3.9v.48h1.87z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineBackwardItem);
export default __webpack_public_path__ + "static/media/vuesax-outline-backward-item.36ef0149d939ffe6da5305a5ebd67314.svg";
export { ForwardRef as ReactComponent };